export default [
  { to: 'akuthandbok', title: 'Akuthandbok' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'doskalkylator', title: 'Doskalkylator' },
  { to: 'info', title: 'Info & Uppdateringar' },
  { to: 'kartor', title: 'Kartor' },
  { to: 'changelog', title: 'Logg' },
];
